import { createReducer, on } from '@ngrx/store';
import { setConfirmationDetails, setRecipient, setStepIndicatorIndex } from '../actions/actions';
import { ConfirmationFlowState } from '../models/state.model';

export const initialState: ConfirmationFlowState = {
  confirmationId: '',
  confirmationDate: '',
  description: '',
  interestedParty: false,
  recipient: {
    confirmationId: '',
    interestedParty: false,
    confirmationDate: '',
    description: '',
    mediaTypeOnFile: '',
    duplicateMediaType: '',
    name: '',
    address: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    addressLine4: '',
    city: '',
    stateCode: '',
    zipCode: '',
    zipCodePlusFour: '',
    foreign: false,
    foreignAddressText: '',
    countryCode: '',
    countryName: ''
  },
  stepIndicatorIndex: 1
};

export const confirmationReducer = createReducer(
  initialState,

  on(setConfirmationDetails, (state, payload) => ({
    ...state,
    confirmationId: payload.confirmationId,
    interestedParty: payload.isInterestedParty,
    confirmationDate: payload.confirmationDate,
    description: payload.description
  })),

  on(setRecipient, (state, payload) => ({
    ...state,
    recipient: {
      ...state.recipient,
      confirmationId: payload.confirmationId,
      interestedParty: state.interestedParty,
      confirmationDate: payload.confirmationDate,
      description: payload.description,
      mediaTypeOnFile: '',
      duplicateMediaType: '',
      name: payload.name,
      address: payload.address,
      addressLine1: payload.addressLine1,
      addressLine2: payload.addressLine2,
      addressLine3: payload.addressLine3,
      addressLine4: payload.addressLine4,
      city: payload.city,
      stateCode: payload.stateCode,
      zipCode: payload.zipCode,
      zipCodePlusFour: payload.zipCodePlusFour,
      foreign: payload.foreign,
      foreignAddressText: payload.foreignAddressText,
      countryCode: payload.countryCode,
      countryName: payload.countryName
    }
  })),

  on(setStepIndicatorIndex, (state, { stepIndicatorIndex }) => ({
    ...state,
    stepIndicatorIndex
  }))
);